export var PaymentSource;
(function (PaymentSource) {
    PaymentSource["platform"] = "platform";
    PaymentSource["api"] = "api";
    PaymentSource["hpp"] = "hpp";
    PaymentSource["portal"] = "portal";
    PaymentSource["lockbox"] = "lockbox";
    PaymentSource["eLockbox"] = "eLockbox";
    PaymentSource["autopay"] = "autopay";
})(PaymentSource || (PaymentSource = {}));
//# sourceMappingURL=PaymentSource.js.map